/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PrintConfigration, { ledgerPaid } from "src/printConfigration/PrintConfigration";

import CustomerCard from "./components/CustomerCard";
import OutstandingCard from "./components/OutstandingCard";
import RefundCard from "./components/RefundCard";
import OrderTable from "./components/OrderTable";
import useSpecifiedLedger from "src/business-types/grocery/hooks/useSpecifiedLedger";
import { PaymentEntry } from "src/shared/services/interface";
import { notifyError } from "src/assets/toastService";
import { postLedgers } from "src/shared/services/services";
import LoadingScreen from "src/shared/components/LoadingScreen";

type Props = {
  pageTitle: (data: string) => void;
};

function SpecifiedLedgerDetails({ pageTitle }: Props) {
  const { ledgerId } = useParams();
  const id = ledgerId || "";

  const [reload, setReload] = useState<any>();
  const { ledgers, loading } = useSpecifiedLedger(id, reload);

  const [payPage, setPayPage] = useState<boolean>(false);
  const [paymode, setPaymode] = useState<string>("Cash");
  const [resPrice, setResPrice] = useState<string>("");
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const [printVisable, setPrintVisible] = useState<boolean>(false);
  const [lastPayment, setLastPayment] = useState<PaymentEntry | undefined>();

  const [selectedOrderAmount, setSelectedOrderAmount] = useState<number | null>(null);
  const [selectedOrderId, setSelectedOrderId] = useState<string>("");
  const [refundInput, setRefundInput] = useState<string>("");

  const now = new Date();
  const localDate =
    now.getFullYear() +
    "-" +
    String(now.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(now.getDate()).padStart(2, "0");

  const navigate = useNavigate();

  useEffect(() => {
    pageTitle(String(ledgers?.customer_ref_id));
  }, [ledgers]);

  const handlePaymentAmount = (amount: string) => {
    const number = Number(amount);
    if (
      !isNaN(number) &&
      number >= 0 &&
      number <= Math.abs(Number(ledgers?.total_outstanding_balance))
    ) {
      setResPrice(amount);
    } else {
      notifyError("Invalid amount");
    }
  };


  const handleRowSelect = (orderAmount: number, orderId: string) => {
    setSelectedOrderAmount(orderAmount);
    setSelectedOrderId(orderId);
    setRefundInput("");
  };

  const payments = () => {
    const balance = Number(ledgers?.total_outstanding_balance) || 0;
    setPageLoading(true);
    const todayTime = now.toTimeString().split(" ")[0].slice(0, 5);
    const data = {
      id: ledgers?.customer_id,
      outstanding_balance: ledgers?.total_outstanding_balance,
      orderamount: "0",
      pay_amount: balance < 0 ? -Number(resPrice) : Number(resPrice),
      order_id: paymode,
      payment_method: paymode,
      Orderdate: localDate,
      Ordertime: todayTime,
    };
    postLedgers(data)
      .then((res) => {
        setLastPayment({ ...data, billNumber: res.data.billNumber });
        setPageLoading(false);
        clearPayment();
        setReload(res);
        setPrintVisible(true);
      })
      .catch((error) => {
        notifyError(error);
        setPageLoading(false);
      });
  };

  const clearPayment = () => {
    setResPrice("");
    setPaymode("Cash");
    setPayPage(false);
  };

  if (loading || pageLoading) return <LoadingScreen />;
  if (!ledgers) return <div className="p-4">Ledger not found</div>;

  const normalizedOrderDetails =
    ledgers?.OrderDetails?.map((item) => ({
      ...item,
      orderid: item.orderid ?? undefined,
    })) ?? null;

  const printData: ledgerPaid = {
    Balance: Number(lastPayment?.outstanding_balance),
    Paid: Number(lastPayment?.pay_amount),
    billNo: Number(lastPayment?.billNumber),
    clientId: String(ledgers?.customer_ref_id),
    CustomerPhon: Number(ledgers?.customer_phone_number),
    CustomerName: ledgers?.customer_name || "",
    Time: now.toTimeString().split(" ")[0].slice(0, 5),
    Date: localDate,
  };

  return (
    <div className="w-full h-[94%] p-3 flex gap-3 bg-slate-100 box-border">
      {/* Main content */}
      <div className="flex-1 flex flex-col gap-3 min-w-0">
        {/* Top Cards */}
        <div className="grid grid-cols-3 gap-3 ">
          <CustomerCard
            name={ledgers?.customer_name}
            phone={ledgers?.customer_phone_number}
            refId={ledgers?.customer_ref_id}
          />
          <OutstandingCard
            balance={ledgers?.total_outstanding_balance}
            payOpen={payPage}
            onTogglePay={() => setPayPage(!payPage)}
          />
          <RefundCard
            balance={ledgers?.total_outstanding_balance}
            paymode={paymode}
            resPrice={resPrice}
            onPaymodeChange={setPaymode}
            onAmountChange={handlePaymentAmount}
            onConfirm={payments}
            onClose={() => setPayPage(false)}
          />
        </div>

        {/* Order Table */}
        <OrderTable
          orders={normalizedOrderDetails}
          selectedOrderId={selectedOrderId}
          onRowSelect={handleRowSelect}
          onNavigate={(orderId) => navigate(`/grocery/orders/${orderId}`)}
        />
      </div>

      {printVisable && (
        <PrintConfigration
          ledgerPaid={printData}
          openPrint={String(printVisable)}
          isClosed={() => setPrintVisible(false)}
        />
      )}
    </div>
  );
}

export default SpecifiedLedgerDetails;